/**
 * Until September 2026 every successful login wrote the user's password here,
 * under 'pass', XOR-obfuscated with the three character key 'crd' that shipped
 * in the JavaScript bundle. That is reversible by anyone who reads the bundle,
 * so the passwords were effectively in the clear: recoverable through any XSS on
 * the domain, or by anyone with access to the browser profile. Because people
 * reuse passwords, the exposure was not limited to this application.
 *
 * The password existed only so the login screen could silently re-authenticate on
 * load. The session cookie already does that job - it is issued by the server and
 * lives for five years - so the client now probes the session instead and never
 * holds a credential.
 *
 * Nothing here writes credentials any more, deliberately. `rememberMe` is
 * untouched: it holds an email address to prefill the login field, which is not a
 * secret.
 */
export const purgeLegacyCredentials = (): void => {
  localStorage.removeItem('pass');
  localStorage.removeItem('user');
};
